import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "offer-full" }
const _hoisted_2 = { class: "tabs offer-tabs" }
const _hoisted_3 = { class: "nav nav-tabs nav-fill" }
const _hoisted_4 = {
  role: "presentation",
  class: "nav-item"
}
const _hoisted_5 = {
  role: "presentation",
  class: "nav-item"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", { class: "d-sm-block d-md-none" }, null, -1)
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = {
  key: 0,
  role: "tabpanel",
  class: "tab-pane active"
}
const _hoisted_9 = {
  key: 1,
  role: "tabpanel",
  class: "tab-pane active"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_LocationPartial = _resolveComponent("LocationPartial")!
  const _component_OfferDetails = _resolveComponent("OfferDetails")!
  const _component_LocationHours = _resolveComponent("LocationHours")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          "hide-background": true
        }))
      : (_openBlock(), _createBlock(_component_LocationPartial, {
          key: 1,
          class: "p-3",
          "display-logo": false,
          location: _ctx.offer!.location,
          "distance-from": _ctx.offer!.distance
        }, null, 8, ["location", "distance-from"])),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            role: "tab",
            class: _normalizeClass(["nav-link", {'active': _ctx.tab === 0}]),
            target: "_self",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.tab = 0), ["prevent"]))
          }, _toDisplayString(_ctx.offerTitle), 3)
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("a", {
            role: "tab",
            class: _normalizeClass(["nav-link", {'active': _ctx.tab === 1}]),
            target: "_self",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.tab = 1), ["prevent"]))
          }, [
            _createTextVNode(" Location "),
            _hoisted_6,
            _createTextVNode(" & Hours ")
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.tab === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_OfferDetails, {
                    key: 0,
                    offer: _ctx.offer!,
                    services: _ctx.offer!.services,
                    "show-for-invoice": _ctx.showForInvoice
                  }, null, 8, ["offer", "services", "show-for-invoice"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.tab === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_LocationHours, {
                "location-hours": _ctx.offer!.location.hours
              }, null, 8, ["location-hours"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}